import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Copy, ArrowUpRight, Heart, MessageSquareReply } from "lucide-react";
import { SENTIMENTS } from "@/lib/api";

const SENT_CLS = { positiva: "bg-emerald-50 text-emerald-700", negativa: "bg-amber-50 text-amber-700", mista: "bg-yellow-50 text-yellow-800", neutra: "bg-slate-100 text-slate-700" };

export const SentimentChip = ({ value }) => (
  <span data-testid="reply-sentiment" className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-[11px] font-semibold ${SENT_CLS[value] || SENT_CLS.neutra}`}>
    {value === "positiva" ? <Heart className="h-3 w-3" /> : <MessageSquareReply className="h-3 w-3" />} {SENTIMENTS[value] || "Comentário"}
  </span>
);

export function ReplyResult({ c }) {
  const a = c.analysis;
  const copy = () => { navigator.clipboard.writeText(c.contest_text); toast.success("Resposta copiada! Cole na plataforma."); };
  return (
    <div className="fade-up rounded-2xl border border-slate-200 bg-white p-5" data-testid="reply-result">
      <SentimentChip value={a.sentimento} />
      <p className="mt-2 font-display font-bold text-slate-900">{a.titulo || "Resposta criada"}</p>
      <p className="text-xs text-slate-500">{c.case_code}{a.resumo ? ` · ${a.resumo}` : ""}</p>
      <p className="mb-1.5 mt-4 text-[10px] font-bold uppercase tracking-[0.18em] text-slate-500">Resposta pública</p>
      <div className="rounded-xl border border-emerald-200 bg-emerald-50/40 p-3 text-sm leading-relaxed text-slate-800" data-testid="reply-text">{c.contest_text}</div>
      <div className="mt-2 flex items-center justify-between">
        <span className="font-mono text-[11px] text-slate-500" data-testid="reply-char-count">{c.contest_text.length} caracteres</span>
        <button data-testid="reply-copy-btn" onClick={copy} className="ai-cta inline-flex h-10 items-center gap-2 rounded-xl px-4 text-sm font-bold text-white"><Copy className="h-4 w-4" /> COPIAR</button>
      </div>
      <Link to={`/recursos/${c.case_id}`} data-testid="open-full-case" className="mt-5 flex h-11 items-center justify-center gap-1 rounded-xl border border-slate-300 text-sm font-semibold text-slate-900 hover:bg-slate-50">Abrir e ajustar o tom <ArrowUpRight className="h-4 w-4" /></Link>
    </div>
  );
}
